import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './SignIn.css';
import { FaEye } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../rtk/thunks/authThunk';
import { FaEyeSlash } from "react-icons/fa6";



const SignIn = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { loading, error, message } = useSelector((state) => state.auth);
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const formatError = (value) => {
        if (!value) return '';
        if (typeof value === 'string') return value;
        if (Array.isArray(value)) return value.filter(Boolean).join(' ');

        return (
            value.detail ||
            value.message ||
            value.non_field_errors?.[0] ||
            value.email?.[0] ||
            value.password?.[0] ||
            Object.values(value)
                .flat()
                .find((item) => typeof item === 'string' && item.trim()) ||
            'Login failed. Please try again.'
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await dispatch(loginUser(formData)).unwrap();
            const from = location.state?.from;
            const nextPath = from?.pathname
                ? `${from.pathname}${from.search || ''}${from.hash || ''}`
                : '/dashboard';
            window.location.href = nextPath.startsWith('/') && !nextPath.startsWith('//')
                ? nextPath
                : '/dashboard';
        } catch (err) {
            // error will be available in slice
        }
    };

    return (
        <div className="signin-container">
            <div className="info-section">
                <div className="info-content">
                    <h1 className="title">
                        <span role="img" aria-label="target" className="target-icon">🎯</span>
                        Prepare Smarter for CPHQ – With AI On Your Side
                    </h1>
                    <p className="subtitle">Your Personalized CPHQ Prep Platform</p>
                    
                    <ul className="features-list">
                        <li>
                          <span className="feature-icon-frame"><img src="/assets/why/study.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>AI Study Planner</h2>
                                <p>Personalized study goals and reminders</p>
                            </div>
                        </li>
                        <li>
                            <span className="feature-icon-frame"><img src="/assets/why/study.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Interactive Content</h2>
                                <p>Flashcards, videos, summaries</p>
                            </div>
                        </li>
                        <li>
                          <span className="feature-icon-frame"><img src="/assets/why/Mock.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Mock Exams</h2>
                                <p>Adaptive quizzes and smart scoring</p>
                            </div>
                        </li>
                        <li>
                         <span className="feature-icon-frame"><img src="/assets/why/performancedashboard.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Performance Dashboard</h2>
                                <p>Visual progress tracking</p>
                            </div>
                        </li>
                        <li>
                            <span className="feature-icon-frame"><img src="/assets/why/aitutor.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>AI Tutor</h2>
                                <p>Ask anything, anytime — Built on GPT-4o</p>
                            </div>
                        </li>
                        <li>
                         <span className="feature-icon-frame"><img src="/assets/why/readness.png" alt="" className="feature-image" /></span>
                            <div className='feature-list'>
                                <h2>Readiness Meter</h2>
                                <p>Know when you're ready to pass</p>
                            </div>
                        </li>
                    </ul>
                    <div className='footer-text'>
                       <p>Built with healthcare professionals in mind. HIPAA-aware. Secure. Mobile-first. Accessible.</p>
                    </div>
                </div>
            </div>
            <div className="form-section">
                <div className="form-content">
                    <h2>Sign in</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="input-group">
                            <input
                                type="email"
                                name="email"
                                placeholder="Your email address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                            {
                                showPassword ? (
                                    <FaEyeSlash className="password-icon" onClick={() => setShowPassword(false)} />
                                ) : (
                                    <FaEye className="password-icon" onClick={() => setShowPassword(true)} />
                                )
                            }
                        </div>
                        <p className="signup-link">
                            <NavLink to="/forgot-password">Forgot password?</NavLink>
                        </p>
                        {error && <p className="form-error" id = "error">{formatError(error)}</p>}
                        {message && <p className="form-success">{message}</p>}
                        <button type="submit" className="login-button" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>
                    <p className="signup-link">
                        Don't have an account? <NavLink to="/sign-up">Sign Up</NavLink>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default SignIn;